import React, { useEffect, useState } from "react";
import { Badge, Paper, Avatar, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import classes from "./myteam.module.css";
import {
  checkOnline,
  generateColor,
  stringAvatar,
} from "../../../utilities/commonFunctions";
import {
  DELETE_DOCUMENT,
  TEAM_MEMBER_DETAILS,
} from "../../../api-calls/api-urls";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { useDispatch, useSelector } from "react-redux";
import { TeamMemberData } from "../../../Redux/actions/team-actions";
import { getLanguagedataFunction } from "../../../utilities/language";
import { CallIcon } from "../../../components/Icons";
import MemberFilesCard, { getDocumentUrl } from "./memberFilesCard";
import MemberEmergencyContactCard from "./memberEmergencyContactCard";
import { toast } from "react-toastify";
import { decodeFileName } from "../../../utilities/fileName";
const TeamMemberDetails = () => {
  const dispatch = useDispatch();
  const [documentDelete, setDocumentDelete] = useState(0);
  const [previewItem, setPreviewItem] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const { teamMemberData } = useSelector((state) => state.teams);
  const ln = useSelector((state) => state.allUsers.language_json);
  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once on mount (getLanguagedataFunction is idempotent)

  const getTeamMemberData = async () => {
    try {
      const path = window.location.pathname.split("/");
      const { data } = await authApi.post(
        `${TEAM_MEMBER_DETAILS}/${path[path?.length - 1]}`,
        {},
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      dispatch(TeamMemberData(data));
    } catch (error) {
      // Intentionally ignored — not surfaced to the user
    }
  };

  useEffect(() => {
    getTeamMemberData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!teamMemberData, documentDelete]);

  const openPreview = (item) => {
    setPreviewItem(item);
    setPreviewUrl(getDocumentUrl(item));
  };

  const downloadFile = () => {
    if (!previewUrl) return;
    window.open(previewUrl, "_blank");
  };

  const closePreview = () => {
    setPreviewItem(null);
    setPreviewUrl(null);
  };

  const deleteDocument = async (doc) => {
    if (
      !window.confirm(
        `${ln.delete || "Delete"} "${decodeFileName(doc.originalname) || ln.document || "Document"}"?`
      )
    ) {
      return;
    }
    try {
      await authApi.delete(
        `${DELETE_DOCUMENT}/${teamMemberData?.user_id?._id}/${doc._id}`
      );
      setDocumentDelete(doc._id);
      toast.success("Document deleted successfully");
    } catch (error) {
      toast.error("Server Error");
    }
  };
  return (
    <div>
      {ln ? (
        <div className={classes.detailspageMaindiv}>
          <Paper className={classes.TeamMemberDetailsPage1}>
            <div className={classes.locationGridCardHeader}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "10px",
                  width: "70%",
                }}
              >
                <Badge
                  color={
                    checkOnline(teamMemberData?.user_id?._id) === "checkin"
                      ? "success"
                      : "error"
                  }
                  badgeContent=" "
                  variant="dot"
                  overlap="circular"
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  className={classes.LocationOnlineBadge}
                >
                  {teamMemberData &&
                  teamMemberData?.user_id &&
                  teamMemberData?.user_id?.profile_pic &&
                  teamMemberData?.user_id?.profile_pic?.filename ? (
                    <Avatar
                      alt={teamMemberData.name}
                      src={`${process.env.REACT_APP_IMAGE_URL}/${teamMemberData?.user_id?.profile_pic?.destination}${teamMemberData?.user_id?.profile_pic?.filename}`}
                      sx={{ width: 40, height: 40 }}
                    />
                  ) : (
                    <Avatar
                      {...stringAvatar(teamMemberData.name)}
                      sx={{
                        bgcolor: teamMemberData.department?.colour
                          ? teamMemberData.department.colour
                          : `${generateColor(teamMemberData.name)}`,
                      }}
                    />
                  )}
                </Badge>
                <div className={classes.memberCardText}>
                  <Typography className={classes.form_lable}>
                    {ln.team_member}
                  </Typography>
                  <Typography className={classes.CardValues}>
                    {teamMemberData.name}
                  </Typography>
                </div>
              </div>
              <div className={classes.memberCardText}>
                <Typography className={classes.form_lable}>
                  {ln.team}
                </Typography>
                <Typography className={classes.CardValues}>
                  {teamMemberData.team.team_name}
                </Typography>
              </div>
              <div className={classes.memberCardText}>
                <Typography className={classes.form_lable}>
                  {ln.mobile_number}
                </Typography>
                <Typography
                  className={`${classes.CardValues} ${classes.phoneIcom}`}
                >
                  {`+91 ${teamMemberData.phone}`}{" "}
                  <span className={classes.form_lable}>|</span> <CallIcon />
                </Typography>
              </div>
              <div className={classes.memberCardText}>
                <Typography className={classes.form_lable}>
                  {ln.department}
                </Typography>
                <Typography className={classes.CardValues}>
                  {teamMemberData.department.department_name}
                </Typography>
              </div>
            </div>
          </Paper>
          <MemberEmergencyContactCard
            userId={teamMemberData?.user_id?._id}
            ln={ln}
          />
          <MemberFilesCard
            documents={teamMemberData?.documents || []}
            ln={ln}
            onDelete={deleteDocument}
            onOpen={openPreview}
          />
        </div>
      ) : null}

      <Dialog open={!!previewItem} onClose={closePreview} maxWidth="md" fullWidth>
        <DialogTitle style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {decodeFileName(previewItem?.originalname)}
          <IconButton onClick={closePreview} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers style={{ minHeight: 300, display: "flex", alignItems: "center", justifyContent: "center" }}>
          {previewItem?.mimetype?.startsWith("image/") && (
            <img src={previewUrl} alt={decodeFileName(previewItem.originalname)} style={{ maxWidth: "100%", maxHeight: 500 }} />
          )}
          {previewItem?.mimetype === "application/pdf" && (
            <embed src={previewUrl} type="application/pdf" width="100%" height="500px" />
          )}
          {previewItem && !previewItem?.mimetype?.startsWith("image/") && previewItem?.mimetype !== "application/pdf" && (
            <Typography>No preview available. Click Download to open the file.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" startIcon={<DownloadIcon />} onClick={downloadFile} disabled={!previewUrl}>
            Download
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TeamMemberDetails;
